import { useGraphQLQuery } from '@opengov/bnp-core';
import { IPublicationTocSettings } from '@opengov/stories-shared/types';

import { graphql } from '../../../../../gql-generated/hasura';
import {
  GetPublicationTocSettingsForOnlinePublicationQuery,
  GetPublicationTocSettingsForOnlinePublicationQueryVariables
} from '../../../../../gql-generated/hasura/graphql';
import { HASURA_SERVICE_URL } from '../../../../../config/config';
import { useToast } from '../../../Toast/context/useToast.context';

import {
  setupOnlinePublicationQueryKeys,
  PublicationIdKeyParams
} from './setupOnlinePublicationQueryKeys';

const GetPublicationTocSettingsForOnlinePublicationDocument = graphql(`
  query GetPublicationTocSettingsForOnlinePublication($id: uuid!) {
    publicationTOCSettings(where: { publicationId: { _eq: $id } }) {
      id
      columnLayoutNumber
      createdBy
      headerHeightSize
      headerImageUrl
      menuTitle
      pageTitle
      showTableOfContents
      createdAt
      publicationId
      updatedAt
      description
      hasUserToggledToc
    }
  }
`);

export type UseTocSettingsParams = PublicationIdKeyParams | null;

export function useTocSettings(params: UseTocSettingsParams, errorMessage: string) {
  const { toggleToast } = useToast();

  return useGraphQLQuery<
    GetPublicationTocSettingsForOnlinePublicationQuery,
    GetPublicationTocSettingsForOnlinePublicationQueryVariables,
    IPublicationTocSettings | null
  >({
    queryKey: params
      ? setupOnlinePublicationQueryKeys.tocSettings(params)
      : ([...setupOnlinePublicationQueryKeys.all, 'tocSettings', 'disabled'] as const),
    document: GetPublicationTocSettingsForOnlinePublicationDocument,
    url: HASURA_SERVICE_URL,
    variables: params ? { id: params.publicationId } : { id: '' },
    options: {
      enabled: params !== null,
      onError: () => {
        toggleToast({ title: errorMessage, severity: 'error' });
      },
      select: (data: GetPublicationTocSettingsForOnlinePublicationQuery): IPublicationTocSettings | null => {
        const row = data.publicationTOCSettings?.[0];
        return row ? (row as unknown as IPublicationTocSettings) : null;
      }
    }
  });
}
